import React from "react";
import { MaterialReactTable } from "material-react-table";
import { TableContainer } from "../../SmartTableContainer.styled";
import { defaultTableConfig } from "../../../../../utils/tableUtils";

const TableView = ({
  columns,
  data,
  rowCount,
  pagination,
  setPagination,
  sorting,
  setSorting,
  isLoading,
  onRowClick,
  enableRowSelection,
  rowSelection = {},
  onRowSelectionChange,
}) => {

  return (
    <TableContainer>
      <MaterialReactTable
        columns={columns}
        data={data || []}
        rowCount={rowCount}
        initialState={{
          sorting,
          rowSelection: {},
        }}
        state={{
          pagination,
          sorting,
          isLoading,
          rowSelection: rowSelection || {},
        }}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        onRowSelectionChange={onRowSelectionChange}
        getRowId={(row) =>
          row?.id || Math.random().toString(36).substring(2, 9)
        }
        muiTableHeadCellProps={{
          sx: {
            "& .Mui-TableHeadCell-Content": {
              fontFamily: "Inter !important",
            },
            fontFamily: "Inter !important",
            paddingInlineStart: enableRowSelection ? "14px" : "8px",
          },
        }}
        muiTableBodyRowProps={({ row }) => {
          const isSelected = row.getIsSelected?.(); // puede ser row.getIsSelected() en MRT

          return {
            onClick: (e) => {
              if (
                !row ||
                !row.original ||
                e.target.closest('[data-menu-wrapper="true"]')
              ) {
                return;
              }
              onRowClick?.(row.original);
            },
            sx: {
              cursor: "pointer",
              position: "relative",
              "&:hover": {
                zIndex: 1
              }
            },
          };
        }}
        muiTableBodyCellProps={{
          sx: {
            verticalAlign: "middle",
          },
        }}
        muiTableContainerProps={{
          sx: {
            height: "calc(100vh - 200px)",
            overflow: "visible !important",
          },
        }}
        muiTablePaperProps={{
          sx: {
            overflow: "visible !important",
          },
        }}
        muiTableProps={{
          sx: {
            overflow: "visible !important",
          },
        }}
        muiPaginationProps={false}
        enableStickyFooter
        {...defaultTableConfig}
        enableBottomToolbar={false}
        enableRowSelection={enableRowSelection}
      />
    </TableContainer>
  );
};

export default TableView;
